import {BackendApi} from '@/services/backend_api'

export default {
  getCurrentUser () {
    return BackendApi.getClient().get(`users/current`)
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/user.js